import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { AgentSettingsFormValues } from '../config/base.config'
import { TURN_DETECTOR_MODEL_FIELD } from '../sidebar/agent-settings/agent-settings.config'

/**
 * The fields the voice config tab renders. Turn detection model is behind
 * `turnDetectorModelSelectionEnabled`: with the flag off it is not rendered, so no
 * FieldApi mounts for it and the value the flow already has rides through the save
 * untouched (voice-config-tab-form owns the whole `voice_ai_config` object).
 */
export const getVoiceSettingsFields = (
  fields: GenericFieldConfig<AgentSettingsFormValues>,
  turnDetectorModelSelectionEnabled: boolean,
): GenericFieldConfig<AgentSettingsFormValues> =>
  fields.filter(
    (field) =>
      field.name.startsWith('voice_ai_config') &&
      (turnDetectorModelSelectionEnabled || field.name !== TURN_DETECTOR_MODEL_FIELD),
  )
